// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"component---src-pages-home-js","85":"component---src-pages-js","883":"component---src-pages-404-js","886":"component---src-templates-article-js"}[chunkId] + "-" + {"79":"16a66bb0a452439052ff","85":"0acae077bc64dc82c379","883":"5fa543a65075c99fc3c4","886":"0fe8ffc93117ad495261"}[chunkId] + ".js";
};